// extracted by mini-css-extract-plugin
var _1 = "LargeTooltip-module__animateUploadProgressBarWidth--HEtbm";
var _2 = "LargeTooltip-module__animatedBackground--ISZ1O";
var _3 = "LargeTooltip-module__button--_3tCk";
var _4 = "LargeTooltip-module__contentContainer--fVB4H";
var _5 = "LargeTooltip-module__heading--g8mKE";
var _6 = "LargeTooltip-module__inner--ZIBI5";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "button", _4 as "contentContainer", _5 as "heading", _6 as "inner" }
